<template>
  <section
    v-if="customer.id"
    class="customers-actions"
  >
    <context-alert v-if="message">
      {{ message }}
    </context-alert>

    <section class="customers-actions-header">
      <form-button-group class="customers-actions-buttons">
        <form-button
          class="customers-actions-button"
          :color="!status || status === STATUS.reset_status_customer ? undefined : 'secondary'"
          :size="size"
          @click="confirm('reset_status_customer')"
        >
          Checagem
        </form-button>

        <form-button
          class="customers-actions-button"
          :color="status === STATUS.validate_customer ? undefined : 'secondary'"
          :size="size"
          @click="confirm('validate_customer')"
        >
          Válido
        </form-button>

        <form-button
          class="customers-actions-button"
          :color="status === STATUS.invalidate_customer ? 'danger' : 'secondary'"
          :size="size"
          @click="confirm('invalidate_customer')"
        >
          Inválido
        </form-button>

        <modal-confirmation
          v-if="confirming"
          :loading="loading"
          title="Atualizar status"
          @close="close"
          @confirm="submit"
        >
          Alterar o status do(a) cliente para <b>{{ label }}</b>?
        </modal-confirmation>
      </form-button-group>

      <form-button
        class="customers-actions-button"
        :size="size"
        color="secondary"
        :href="profile"
      >
        Ir para a página do(a) cliente
      </form-button>
    </section>
  </section>
</template>

<script>
  import { mapState } from 'vuex';

  import ContextAlert from '@cordel/components/Context/Alert.vue';
  import FormButton from '@cordel/components/Form/Button.vue';
  import FormButtonGroup from '@cordel/components/Form/Button/Group.vue';

  import ModalConfirmation from '@cordel/components/Modal/Confirmation.vue';

  import resize from '@sdk/helpers/interface/mobile';

  const STATUS = {
    reset_status_customer: 'checagem',
    validate_customer: 'valido',
    invalidate_customer: 'inválido',
  };

  const LABELS = {
    reset_status_customer: 'Checagem',
    validate_customer: 'Válido',
    invalidate_customer: 'Inválido',
  };

  export default {
    name: 'CustomerActions',
    components: {
      ContextAlert,
      FormButton,
      FormButtonGroup,

      ModalConfirmation,
    },
    mixins: [
      resize,
    ],
    data() {
      return {
        confirming: null,
        STATUS,
      };
    },
    computed: {
      ...mapState([
        'customers',
        'proposals',
      ]),

      customer() {
        return this.customers.read.item;
      },
      proposal() {
        return this.proposals.status.item;
      },
      loading() {
        return this.proposals.status.loading;
      },
      status() {
        return this.proposal.state === undefined ? this.customer.state : this.proposal.state;
      },
      label() {
        return LABELS[this.confirming];
      },

      profile() {
        return {
          name: 'customers-read-profile',
          params: {
            id: this.customer.id,
          },
        };
      },

      error() {
        return this.proposals.status.error;
      },

      message() {
        if (this.error && this.error.status === 401) {
            return 'Você não possui permissão para executar esta ação.';
        }
        if (this.error && this.error.status !== 401) {
            return 'Oops! Algo deu errado.';
        }
        return null;
      },

      size() {
        if (this.sdk.mobile) {
          return 'small';
        }

        return undefined;
      },
    },
    methods: {
      confirm(state) {
        this.confirming = state;
      },
      close() {
        this.confirming = null;
      },

      submit() {
        this.$store
          .dispatch('proposals/status', {
            id: this.$route.params.id,
            status: this.confirming,
          })
          .finally(this.submitted);
      },
      submitted() {
        this.confirming = null;
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '@cordel/assets/stylesheets/mixins/reset.scss';
  @import '@cordel/assets/stylesheets/variables/breakpoints.scss';

  .customers-actions {
  }

  .customers-actions-header {
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin: var(--cordel-legacy-spacing-xl) 0;

    &:first-child {
      margin-top: 0;
    }

    @media all and (max-width: $cordel-breakpoint-mobile) {
      align-items: stretch;
      flex-direction: column;
      justify-content: center;
    }
  }

  .customers-actions-buttons {
    @media all and (max-width: $cordel-breakpoint-mobile) {
      margin-bottom: var(--cordel-legacy-spacing-s);
      justify-content: stretch;
    }
  }

  .customers-actions-button {
    @media all and (max-width: $cordel-breakpoint-mobile) {
      flex: 1;
    }
  }
</style>
